/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Hip_AdductionInputs */

const en_us2_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hip adduction`)
};

const pt_br2_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adução de quadril`)
};

const es_419_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aducción de cadera`)
};

const pt_pt2_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adução da anca`)
};

const fr_fr2_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adduction de hanche`)
};

const de_de2_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüftadduktion`)
};

const it_it2_catalog_movement_hip_adduction = /** @type {(inputs: Catalog_Movement_Hip_AdductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adduzione dell'anca`)
};

/**
* | output |
* | --- |
* | "hip adduction" |
*
* @param {Catalog_Movement_Hip_AdductionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_hip_adduction = /** @type {((inputs?: Catalog_Movement_Hip_AdductionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Hip_AdductionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_hip_adduction(inputs)
	if (locale === "es-419") return es_419_catalog_movement_hip_adduction(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_hip_adduction(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_hip_adduction(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_hip_adduction(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_hip_adduction(inputs)
	return en_us2_catalog_movement_hip_adduction(inputs)
});
export { catalog_movement_hip_adduction as "catalog.movement.hip_adduction" }